import 'css-chunksrc/client/pages/obsPage/toolbar/resourceStatusFilter/styles.scss';export default {
  "resourceStatusFilter": "_resourceStatusFilter_574xx_1",
  "label": "_label_574xx_7",
  "dropdown": "_dropdown_574xx_13",
  "input": "_input_574xx_17",
  "toggleArrow": "_toggleArrow_574xx_33",
  "selectedStatuses": "_selectedStatuses_574xx_43",
  "placeholder": "_placeholder_574xx_50",
  "list": "_list_574xx_56",
  "item": "_item_574xx_69",
  "unchecked": "_unchecked_574xx_80",
  "statusName": "_statusName_574xx_98",
  "opened": "_opened_574xx_105"
};